import { render, staticRenderFns } from "./lazadachat.vue?vue&type=template&id=09411586"
import script from "./lazadachat.vue?vue&type=script&lang=js"
export * from "./lazadachat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports